import { render, staticRenderFns } from "./HeroSliderNew.vue?vue&type=template&id=cb06bdbc&scoped=true&"
import script from "./HeroSliderNew.vue?vue&type=script&lang=js&"
export * from "./HeroSliderNew.vue?vue&type=script&lang=js&"
import style0 from "./HeroSliderNew.vue?vue&type=style&index=0&id=cb06bdbc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb06bdbc",
  null
  
)

export default component.exports